class MainController {

    constructor(){
    }

}

MainController.$inject = [];
export default MainController;
